import { call, put, takeLatest } from "redux-saga/effects"
import { toast } from "react-toastify"
import {
  FETCH_CURRENT_SUBSCRIPTION,
  FETCH_PLANS,
  FETCH_INVOICE_INFO,
  CALCULATE_PRICE,
  VALIDATE_COUPON,
  PURCHASE_SUBSCRIPTION,
  FETCH_SUBSCRIPTION_HISTORY,
  SCHEDULE_DOWNGRADE,
  CANCEL_SUBSCRIPTION,
} from "./actionTypes"
import {
  fetchCurrentSubscriptionSuccess,
  fetchPlansSuccess,
  fetchInvoiceInfoSuccess,
  calculatePriceSuccess,
  validateCouponSuccess,
  purchaseSubscriptionSuccess,
  fetchSubscriptionHistorySuccess,
  scheduleDowngradeSuccess,
  cancelSubscriptionSuccess,
  fetchSubscriptionHistory,
  fetchCurrentSubscription,
  fetchPlans,
  subscriptionApiError,
  setSubscriptionResolved,
} from "./actions"
import {
  getCurrentSubscription,
  getAvailablePlans,
  getInvoiceInfo,
  calculatePrice as calculatePriceApi,
  validateCoupon as validateCouponApi,
  purchaseSubscription as purchaseSubscriptionApi,
  getSubscriptionHistory,
  scheduleDowngrade as scheduleDowngradeApi,
  cancelSubscription as cancelSubscriptionApi,
} from "../../api/requests/subscription-requests"

function* fetchCurrentSubscriptionSaga() {
  try {
    const response = yield call(getCurrentSubscription)
    yield put(fetchCurrentSubscriptionSuccess(response.data))
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  } finally {
    // Başarılı ya da hatalı — durum sorgulandı; gate spinner'da asılı kalmasın
    yield put(setSubscriptionResolved())
  }
}

function* fetchPlansSaga() {
  try {
    const response = yield call(getAvailablePlans)
    yield put(fetchPlansSuccess(response.data))
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  }
}

function* fetchInvoiceInfoSaga() {
  try {
    const response = yield call(getInvoiceInfo)
    yield put(fetchInvoiceInfoSuccess(response.data))
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  }
}

function* calculatePriceSaga({ payload }) {
  try {
    const response = yield call(calculatePriceApi, payload)
    yield put(calculatePriceSuccess(response.data))
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  }
}

function* validateCouponSaga({ payload }) {
  try {
    const response = yield call(validateCouponApi, payload)
    yield put(validateCouponSuccess(response.data))
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  }
}

function* purchaseSubscriptionSaga({ payload: { data, history } }) {
  try {
    const response = yield call(purchaseSubscriptionApi, data)
    yield put(purchaseSubscriptionSuccess(response.data))
    if (history) {
      history("/subscription/history")
    }
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  }
}

function* fetchSubscriptionHistorySaga() {
  try {
    const response = yield call(getSubscriptionHistory)
    yield put(fetchSubscriptionHistorySuccess(response.data))
  } catch (error) {
    yield put(subscriptionApiError(error.message))
  }
}

function* scheduleDowngradeSaga({ payload }) {
  try {
    const response = yield call(scheduleDowngradeApi, payload.targetPlanId, payload.reason)
    yield put(scheduleDowngradeSuccess(response.data))
    toast.success(response.message || "Plan düşürme başarıyla planlandı.", { position: "top-right", autoClose: 3000 })
    yield put(fetchPlans())
    yield put(fetchCurrentSubscription())
  } catch (error) {
    toast.error(error.message || "Plan düşürme işlemi başarısız.", { position: "top-right", autoClose: 3000 })
    yield put(subscriptionApiError(error.message))
  }
}

function* cancelSubscriptionSaga({ payload }) {
  try {
    const response = yield call(cancelSubscriptionApi, payload.reason)
    yield put(cancelSubscriptionSuccess(response.data))
    toast.success(response.message || "Abonelik iptal edildi.", { position: "top-right", autoClose: 3000 })
    yield put(fetchCurrentSubscription())
    yield put(fetchSubscriptionHistory())
  } catch (error) {
    toast.error(error.message || "Abonelik iptal edilemedi.", { position: "top-right", autoClose: 3000 })
    yield put(subscriptionApiError(error.message))
  }
}

function* subscriptionSaga() {
  yield takeLatest(FETCH_CURRENT_SUBSCRIPTION, fetchCurrentSubscriptionSaga)
  yield takeLatest(FETCH_PLANS, fetchPlansSaga)
  yield takeLatest(FETCH_INVOICE_INFO, fetchInvoiceInfoSaga)
  yield takeLatest(CALCULATE_PRICE, calculatePriceSaga)
  yield takeLatest(VALIDATE_COUPON, validateCouponSaga)
  yield takeLatest(PURCHASE_SUBSCRIPTION, purchaseSubscriptionSaga)
  yield takeLatest(FETCH_SUBSCRIPTION_HISTORY, fetchSubscriptionHistorySaga)
  yield takeLatest(SCHEDULE_DOWNGRADE, scheduleDowngradeSaga)
  yield takeLatest(CANCEL_SUBSCRIPTION, cancelSubscriptionSaga)
}

export default subscriptionSaga
